export default __webpack_public_path__ + "static/cnp4w-60973e693668a1c72613de1b0abbed24.png";